/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_contains.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Checks if all values yielded by the second multivalue expression are present in the values yielded by the first multivalue expression. Returns a boolean. Null values are treated as an empty set.',
  examples: [
    'ROW set = ["a", "b", "c"], element = "a"\n| EVAL set_contains_element = mv_contains(set, element)',
    'ROW setA = ["a","c"], setB = ["a", "b", "c"]\n| EVAL a_subset_of_b = mv_contains(setB, setA)\n| EVAL b_subset_of_a = mv_contains(setA, setB)',
    'FROM airports\n| WHERE mv_contains(type, ["major","military"]) AND scalerank == 9\n| KEEP scalerank, name, country',
  ],
  params: {
    superset: 'Expression that can be null, a single value, or multiple values.',
    subset: 'Expression that can be null, a single value, or multiple values.',
  },
};

export default docs;
